import { CancelToken } from 'apisauce';
import shortid from 'shortid';
import cn from 'classnames';

import appConfig from 'src/appConfig';
import { Content } from 'src/redux/contentRedux/types';
import { isEmpty } from 'src/validations';

export function newCancelToken(timeout = appConfig.CONNECTION_TIMEOUT) {
  const source = CancelToken.source();
  setTimeout(() => {
    source.cancel();
  }, timeout);

  return { cancelToken: source.token };
}

export const getRandomId = (): string => shortid.generate();

export const generateArray = (length: number, initial = '') => Array(length).fill(initial);

export const stringify = (params: { [key: string]: number | string | string[] | undefined }) => {
  let result = '';

  Object.keys(params).forEach(key => {
    if (!isEmpty(params[key])) {
      if (Array.isArray(params[key])) {
        let array = params[key] as string[];
        array.forEach((param: string) => {
          result += `&${key}=${param}`;
        });
      } else {
        result += `&${key}=${params[key]}`;
      }
    }
  });

  result = result.replace(/^&/, '');

  return result;
};

export const contentLookup = (options: Content[], id: number) => {
  const found = options.find(x => x.id === id);
  if (!found) return '';
  return found.name;
};

export const contentLookupByName = (options: Content[], name: string): number => {
  const found = options.find(x => x.name === name);
  if (!found) return 0;
  return found.id;
};

export const getYesNo = (value: boolean, highLightValue = 'YES') => {
  if (isEmpty(value)) return '';
  const result = value ? 'YES' : 'NO';
  const isHighLight = highLightValue === result;
  return <span className={cn({ 'has-text-danger': isHighLight })}>{result}</span>;
};

export const getUserPositionDisplay = (value: string) => {
  try {
    return value.toLocaleLowerCase().replaceAll('_', ' ');
  } catch (error) {
    console.log('getUserPositionDisplay', error);
    return value;
  }
};
export const getSortParam = (value: string) => {
  try {
    return value.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).toUpperCase();
  } catch (error) {
    console.log('getSortParam', error);
    return value;
  }
};
